import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import axiosIns from "../common/interceptor/axios-interceptor";

//DTN
//Fetch DTN data
export const fetchDTNData = async () => {
  try {
    const res = await axiosIns.get(`rackstar/dtn`);
    return getSuccessRes(res.data || [], "DTN data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch DTN data.`);
  }
};

//Fetch DTN data by ID
export const fetchDTNDataById = async (id) => {
  try {
    const res = await axiosIns.get(`rackstar/dtn/${id}`);
    return getSuccessRes(res.data || [], "DTN data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch DTN data.`);
  }
};

//DTN
//Fetch DTN Data With Filters
export const fetchDTNDataWithFilters = async (params) => {
  try {
    const res = await axiosIns.get(
      `rackstar/dtn-with-filter`,
      { params }
    );
    return getSuccessRes(res.data || [], "DTN data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, false);
    throw getErrorRes(errMessage, `Failed to fetch DTN data.`);
  }
};
